import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Needed for react-router to scroll to top when changing page
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (pathname !== prevPathname.current) {
      window.scrollTo(0, 0);
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return null;
}
